<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="handleBatchDelete">{{ $t('批量删除') }}</el-button>
      <el-button @click.native="handleBatchRecommend">{{ $t('批量精品置顶') }}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('编号')">
        <el-input :placeholder="$t('编号')" v-model="searchForm.num" clearable/>
      </el-form-item>
      <el-form-item :label="$t('发布者编号')">
        <el-input :placeholder="$t('发布者编号')" v-model="searchForm.userNum" clearable/>
      </el-form-item>

      <el-form-item :label="$t('搜索文字')">
        <el-input :placeholder="$t('搜索文字')" v-model="searchForm.content" clearable/>
      </el-form-item>

      <el-form-item :label="$t('话题')">
        <el-input :placeholder="$t('话题')" v-model="searchForm.topicName" clearable/>
      </el-form-item>

      <el-form-item :label="$t('发布时间')">
        <date-time-range-picker
            :end-time.sync="searchForm.endCreateTime"
            :start-time.sync="searchForm.startCreateTime" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button @click="$refs.list.reset()">{{ $t('重置') }}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">

      <table-list
          :height="height"
          ref="list"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>

        <el-table-column prop="num" :label="$t('编号')" fixed />
        <el-table-column prop="content" :label="$t('内容')">
          <template v-slot="{row}">
            <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                :content="row.content">
              <span slot="reference" class="content">{{row.content}}</span>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column :label="$t('图片')">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <template  v-for="(pic, index) in row.photoList">
                <el-image
                    @click="$router.push('edit?code=' + row.code)"
                    v-if="index < 1"
                    :key="index"
                    :src="pic" />
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="topic" :label="$t('话题')" />
        <el-table-column prop="userNum" :label="$t('发布者编号')"/>
        <el-table-column prop="username" :label="$t('发布者昵称')"/>
        <el-table-column :label="$t('评论数')">
          <template v-slot="{row}">
            <el-link :underline="false" type="primary" @click="handleCommentPage(row)">{{ row.commentCount || 0 }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="baseLike" :label="$t('点赞数')"/>
        <el-table-column prop="createTimeStr" :label="$t('发布时间')"/>
        <el-table-column prop="topping" :label="$t('精品置顶')"/>
        <el-table-column fixed="right" :label="$t('操作')" min-width="70">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="$router.push('detail?code=' + row.code)">{{ $t('查看') }}</el-link>
              <el-link type="primary" :underline="false" @click="$router.push('edit?code=' + row.code)">{{ $t('编辑') }}</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{ $t('删除') }}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker.vue";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "DynamicList",
  components: {AnkhList, DateTimeRangePicker, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
    }
  },
  methods: {
    handleCommentPage(row) {
      this.$router.push({
        path: "/comment/list",
        query: {
          code: row.code,
          num: row.num,
        }
      })
    },

    // 批量设置推荐
    async handleBatchRecommend() {
      try {
        let codes = this.selection.map(item => item.code);
        if(!codes.length) {
          this.$message.warning(this.$t('请选择要操作的数据'));
          return;
        }
        await requestByTip(this.$api.dynamics.batchUpdate, codes, {isJson: true}, {message: this.$t('是否确认设置为精品置顶')});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      }catch(e) {
         console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.dynamics.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.dynamics.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();

      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.dynamics.list, params);
        this.tableData = res.dynamicss.map(item => {
          const photoList = item.photo ? item.photo.split(",") : [];
          item.photoList = photoList.map(p => this.$api.file.downloadImg + p);
          item.createTimeStr = this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
          return item;
        })
        setTotal(res.pager.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

.content {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

</style>
